import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type SearchProps = IconComponentBaseProps;

export const Search = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: SearchProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7285_3385"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7285_3385)">
        <path
          d="M9.51924 15.6152C7.81157 15.6152 6.36541 15.023 5.18074 13.8385C3.99624 12.6538 3.40399 11.2077 3.40399 9.49998C3.40399 7.79232 3.99624 6.34615 5.18074 5.16149C6.36541 3.97699 7.81157 3.38474 9.51924 3.38474C11.2269 3.38474 12.6731 3.97699 13.8577 5.16149C15.0422 6.34615 15.6345 7.79232 15.6345 9.49998C15.6345 10.2142 15.5147 10.8962 15.275 11.5462C15.0352 12.1962 14.7152 12.7616 14.3152 13.2422L20.0692 18.9962C20.2077 19.1346 20.2786 19.3086 20.2817 19.5182C20.2849 19.7279 20.2141 19.9052 20.0692 20.05C19.9244 20.1948 19.7487 20.2672 19.5422 20.2672C19.3359 20.2672 19.1603 20.1948 19.0155 20.05L13.2615 14.296C12.7615 14.7088 12.1865 15.0319 11.5365 15.2652C10.8865 15.4986 10.2141 15.6152 9.51924 15.6152ZM9.51924 14.1155C10.8077 14.1155 11.8991 13.6683 12.7932 12.774C13.6876 11.8798 14.1347 10.7885 14.1347 9.49998C14.1347 8.21148 13.6876 7.12015 12.7932 6.22598C11.8991 5.33165 10.8077 4.88448 9.51924 4.88448C8.23074 4.88448 7.13941 5.33165 6.24524 6.22598C5.35091 7.12015 4.90374 8.21148 4.90374 9.49998C4.90374 10.7885 5.35091 11.8798 6.24524 12.774C7.13941 13.6683 8.23074 14.1155 9.51924 14.1155Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
